import { Dispatch, SetStateAction } from 'react';

import Container from '@ui/container/container';
import Modal from '@ui/modal/modal';
import Text from '@ui/text/text/text';
import Button from '@ui/buttons/button/button';
import getThemeColorCSSVariable from '@/utils/colors/get-theme-color-css-variable';
import getThemeColorContrastCSSVariable from '@/utils/colors/get-theme-color-contrast-css-variable';
import getThemeColorsCssMixVariable from '@/utils/colors/get-theme-color-css-mix-variable';

type CourseDeleteModalProps = {
  showDeleteModal: boolean;
  setShowDeleteModal: Dispatch<SetStateAction<boolean>>;
  courseName: string;
  onDelete: () => void;
  working: boolean;
};

const CourseDeleteModal = ({
  showDeleteModal,
  setShowDeleteModal,
  courseName,
  onDelete,
  working,
}: CourseDeleteModalProps) => {
  const handleClose = () => {
    setShowDeleteModal(false);
  };

  return (
    <Modal
      open={showDeleteModal}
      customSize={{
        width: '600px',
        height: 'auto',
        maxHeight: '300px',
        minHeight: '200px',
        maxWidth: 'calc(100vw - 80px)',
      }}
      contentWrapperClassName="padding-h-40 padding-v-24 gap-40"
      onRequestClose={handleClose}
      RenderHeaderContent={() => {
        return (
          <Container className="radius-10">
            <Text clamp={2} whiteSpace="wrap" tag="h3" color="var(--gray-100)" className="H3 margin-b-8">
              {courseName ? `Delete '${courseName}'` : 'Delete Course'}
            </Text>
          </Container>
        );
      }}
      RenderFooterContent={() => {
        return (
          <Container borderRadius="0 0 12px 12px" className="flex fd-row jc-flex-end ai-center gap-16">
            <Button design="LocalBttnSecHalfTransp" designSize="large" onClick={handleClose}>
              <Text className="L1">Cancel</Text>
            </Button>
            <Button
              backgroundColor={getThemeColorCSSVariable()}
              hoverBackgroundColor={getThemeColorsCssMixVariable()}
              designSize="large"
              loading={working}
              disabled={working}
              onClick={onDelete}
            >
              <Text className="L1" color={getThemeColorContrastCSSVariable()}>
                Delete
              </Text>
            </Button>
          </Container>
        );
      }}
    >
      <Container className="overflow-auto" height="100%">
        <Text tag="p" color="var(--gray-300)" className="P1">
          Are you sure you want to delete this course?
        </Text>
      </Container>
    </Modal>
  );
};

export default CourseDeleteModal;
